// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spewpa: PokeData = {
  "id": 665,
  "name": "spewpa",
  "height": 3,
  "weight": 84,
  "base_experience": 75,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "harden",
    "protect"
  ],
  "moves": [
    "protect",
    "leech-steal",
    "string-shot",
    "bug-bite",
    "heal-order",
    "pin-rush",
    "pounce",
    "infest",
    "bug-buzz",
    "lunge",
    "signal-spam",
    "pin-missile",
    "sticky-web"
  ],
  "evolution_chain": {
    "id": 342,
    "item": null,
    "species": [
      {
        "name": "scatterbug",
        "order": 665,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "spewpa",
        "order": 666,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 664,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 9,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vivillon",
        "order": 667,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 665,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 12,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 29,
    "ability_power": 27
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
